/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simplified_ChineseInputs */



/**
* | output |
* | --- |
* | "Simplified Chinese" |
*
* @param {Simplified_ChineseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const simplified_chinese = /** @type {((inputs?: Simplified_ChineseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simplified_ChineseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chinois simplifié")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vereinfachtes Chinesisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("cinese semplificato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Упрощенный китайский")
	if (locale === "es") return /** @type {LocalizedString} */ ("Chino simplificado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("简体中文")
	if (locale === "ja") return /** @type {LocalizedString} */ ("簡体字中国語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सरलीकृत चीनी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Chinês simplificado")
	return /** @type {LocalizedString} */ ("Simplified Chinese")
});